import clsx from 'clsx';
import { Path, UseFormRegister } from 'react-hook-form';
import { IProfileForm } from '../../../../models/Profile/IProfileForm';
import styles from './TextFieldEdit.module.css';

type ProfileReadModeProps = {
  property: Path<IProfileForm>;
  register: UseFormRegister<IProfileForm>;
  required?: boolean;
  label?: string;
  propStyle?: string;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  maxLength?: number;
  message?: string;
  validationFn?: (value: any) => boolean | string;
  note?: boolean;
};

const TextFieldEdit = (props: ProfileReadModeProps) => {
  // const { register, property, required, label, propStyle, value, error, placeholder } = props;
  const {
    register,
    property,
    required,
    label,
    propStyle,
    disabled,
    error,
    placeholder,
    maxLength,
    message,
    validationFn,
    note,
  } = props;
  return (
    <div className={clsx(styles.container, propStyle)}>
      {props.label && (
        <label className={clsx(styles.label, error && styles.errorLabel)}>{label}</label>
      )}
      {required && <span style={{ color: 'var(--shrmRed)' }}>*</span>}
      <div className={note && styles.noteContainer}>
        <input
          className={clsx(styles.inputText, error && styles.error)}
          type='text'
          {...(placeholder && { placeholder })}
          {...register(property, {
            required,
            validate: validationFn,
            maxLength: {
              value: maxLength - 1,
              message: message,
            },
          })}
          disabled={disabled}
          maxLength={maxLength}
        />
        {note && (
          <p className={styles.noteText}>
            Please add an alternative email address for communication purposes.
          </p>
        )}
      </div>
    </div>
  );
};

export default TextFieldEdit;
